import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs/Subscription";
import {GlobalService} from "../../services/global.service";
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {ActivatedRoute, Router} from "@angular/router";
import {MyQueryHistoryService} from "../../services/my-query-history.service";
import {PageService} from "../../services/page.service";
import {SuperviseService} from "../../services/supervise.service";
import {Title} from "@angular/platform-browser";
import {SearchService} from "../../services/search.service";
import {HttpCommonService} from "../../services/http-common.service";
import {Observable} from "../../../../node_modules/rxjs";
import {LoginModalComponent} from "../login-modal/login-modal.component";
import {Page} from "../../models/page";

@Component({
  selector: 'app-enterp-news-info',
  templateUrl: './enterp-news-info.component.html',
  styleUrls: ['./enterp-news-info.component.css']
})
export class EnterpNewsInfoComponent implements OnInit, AfterViewInit, OnDestroy {

  totals = 0;

  showTotals = 0;

  showPrompt: any = true;

  moreThan: any = true;

  // 省份
  public provinces = [];

  // 行业门类
  public industris = [];

  // 公司数据
  public enterpList = [];

  @Input() useClass = 0;// 使用样式 0首页 1大屏 2企业注册
  companyList: Company[] = [];// 查询结果数组

  company: Company;// 传值

  showResultDiv = false;// 是否收起结果下拉框

  keyWord = '';// 输入框关键词

  userId: any;
  userName: any;
  fromType: any;

  oldKeyWord = '';// 输入框旧值

  // 历史搜索数据
  public historyList = [];

  // 关键词
  public keyword = "";

  pageSubscription: Subscription;

  params: SearchParams = new SearchParams();

  searchEventSub: Subscription;// 搜索事件流的订阅

  userType: any;

  isVip = false;

  //titel修改
  titelCofig:any;

  // 用户根据用户权益，能获取的搜索企业数量；游客默认200家
  showNum = 200;

  constructor(private searchService: SearchService, private showMsg: NzMessageService,
              private elementRef: ElementRef, private pageSev: PageService,
              private superviseServ: SuperviseService, private router: Router,
              private supSev: SuperviseService, private httpService: HttpCommonService,
              private showAlert: NzModalService, private globalService: GlobalService,
              private queryHisServ: MyQueryHistoryService, private routerInfo: ActivatedRoute,
              private titleService:Title) {
    this.userId = this.routerInfo.snapshot.queryParams['userId'];
    this.userName = this.routerInfo.snapshot.queryParams['userName'];
    this.fromType = this.routerInfo.snapshot.queryParams['fromType'];
    /*this.userType = this.globalService.getUserInfo("_userType");
    //查看企业是否为机构用户
    this.httpService.get("/user/center/xhsRest/hasPermission", {permissionId: "company:checkSupervise"})
      .subscribe(data => this.isVip = data.data > 0);

    if ('enterprise' == this.userType || 'person' == this.userType) {

      // 获取权益数据 展示搜索企业数量
      this.httpService.get("/user/center/xhsRest/findTypeOperationCount", {customerPermissionId: "company:showNumber"})
        .subscribe((data) => {
          this.showNum = data.data;
        });
    }*/
  }

  ngOnInit() {
    this.titleService.setTitle('企业舆情搜索');
    //声明隐藏头部搜索框

    this.searchService.searchIsShow.emit(true);

    this.keyword = this.routerInfo.snapshot.queryParams['keyWord'];
    if (this.keyword) {
      this.searchByConditon();
    }
    this.pageSubscription = this.pageSev.pageChange.debounceTime(0).subscribe(
      page => {
        this.params.page = page;
        this.advanceSearch();
      }
    );

    $("#keyword").keydown((e) => {
      if (e.keyCode == 13) {
        //this.searchByConditon(this.page);
      }
    });

    // this.searchByConditon(this.page);
    this.getProvinces();
  }

  /**
   * 输入框键盘事件
   */
  inputSomething(event: any) {
    if (event.keyCode == 13) {// enter
      this.searchByConditon(1);
    } else if (event.keyCode == 38) {// 上
      this.showMsg.info('上');
      if (!this.keyWord) {
        return;
      }
      let index = this.companyList.findIndex(company => company.isHighlight);
      if (index == -1) {
        this.companyList[this.companyList.length - 1].isHighlight = true;
        this.keyWord = this.companyList[this.companyList.length - 1].companyName;
      } else if (index == 0) {
        this.companyList[index].isHighlight = false;
        this.keyWord = this.oldKeyWord;
      } else {
        this.companyList[index].isHighlight = false;
        this.companyList[index - 1].isHighlight = true;
        this.keyWord = this.companyList[index - 1].companyName;
      }
    } else if (event.keyCode == 40) {// 下
      this.showMsg.info('下');
      if (!this.keyWord) {
        return;
      }
      let index = this.companyList.findIndex(company => company.isHighlight);
      if (index == -1) {
        this.companyList[0].isHighlight = true;
        this.keyWord = this.companyList[0].companyName;
      } else if (index == this.companyList.length - 1) {
        this.companyList[index].isHighlight = false;
        this.keyWord = this.oldKeyWord;
      } else {
        this.companyList[index].isHighlight = false;
        this.companyList[index + 1].isHighlight = true;
        this.keyWord = this.companyList[index + 1].companyName;
      }
    }
  }


  // 根据条件分页查询
  searchByConditon(type?:any) {
    this.params.conditions['Name'] = $.trim(this.keyword);
    if ($.trim(this.keyword) == "") {
      this.showMsg.error("请输入查询关键词");
      return;
    } else {
      this.params.page.pageNo = 1;
      this.advanceSearch();
      //添加搜索历史
      // this.queryHisServ.addQueryHistory(this.keyword).subscribe(result => {
      // });
    }

    if (type == 1) {
      this.router.navigate(['/enterpNewsInfo'], {queryParams: {userId: this.userId, userName: this.userName, keyWord: this.keyword}});
    }
  }

  compareSort(property) {
    return function (a, b) {
      var value1 = a[property] ? a[property] : 0;
      var value2 = b[property] ? b[property] : 0;
      return value2 - value1;
    };
  }

  advanceSearch() {
    this.params.conditions['pageNo'] = this.params.page.pageNo;
    this.params.conditions['pageSize'] = this.params.page.pageSize;
    if ($.trim(this.keyword) == '') {
      this.params.conditions['Name'] = '';
      this.params.conditions['OperName'] = '';
    } else {
      this.params.conditions['OperName'] = '1'; // 1表示后台需要根据关键词匹配企业名称或者法定代表人
    }

    this.params.conditions['isFromSearch'] = '1'; // 1表示是从高级搜索页调用的接口

    this.httpService.post("/enterprise/detail/xhsRest/search/companyNewsInfoSearchByPage",
      this.params.conditions).subscribe(data => {
      if (data.stateCode == '50001') {
        console.log(data);
        let result = data.data;
        this.enterpList = result.returnData;
        this.showTotals = result.totalCount || 0;
        this.totals = result.totalCount || 0;

      } else if (data.stateCode == '50103') {
        this.showMsg.error("请输入更详细的关键词");
        return;
      } else { // 50102查询失败，60100查询为空
        if (data.stateCode == '60100') {
          this.showMsg.error("查询结果为空");
        } else {
          this.showMsg.error("查询失败");
        }
        this.enterpList = [];

        this.showTotals = 0;

        this.totals = 0;
      }
    }, error => {
    });
  }

  // 导出数据
  exportData() {

    if (this.userType != "enterprise" && this.userType != "person") {
      let thiss = this;
      this.showAlert.open({
        zIndex: 5,
        content: LoginModalComponent,
        width: 360,
        footer: false,
        onCancel() {
        },
        onOk() {
          console.log('sssswwwqqqq');
        }
      });
      return;
    }
    if (this.showTotals < 1) {
      this.showMsg.error("没有数据可以导出");
      return;
    }
    this.params.conditions['pageNo'] = this.params.page.pageNo;
    this.params.conditions['pageSize'] = this.params.page.pageSize;
    this.searchService.exportData(this.params).subscribe(data => {
      let blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      let objectUrl = URL.createObjectURL(blob);
      let aForExcel = $("<a id='forExcel'><span class='forExcel'>下载excel</span></a>").attr("href", objectUrl)
        .attr("download", "企业名称列表.xlsx");
      $("body").append(aForExcel);

      try {
        document.getElementById("forExcel").click();
      } catch (e) {
        navigator.msSaveBlob(blob,  "企业名称列表.xlsx");
      }
      aForExcel.remove();
    }, error => {
    });


  }

  ngAfterViewInit(): void {
    //订阅输入框keyup事件流
    let inputEle = this.elementRef.nativeElement.querySelector('.show-con a');
    this.searchEventSub = Observable.fromEvent(inputEle, 'click')
      .debounceTime(400)
      .subscribe(e => {
      });
  }

  ngOnDestroy(): void {
    //取消订阅，释放资源
    this.pageSubscription.unsubscribe();
    //声明隐藏头部搜索框
    this.searchService.searchIsShow.emit(false);
  }

  getProvinces() {
    this.searchService.getProvinces().subscribe(data => {
      if (data.stateCode == "1") {
        this.provinces = data.data;
      } else if (data.stateCode == "0") {
        this.showMsg.error("省份条件查询失败");
      }
      this.getIndustryCategory();
    }, error => {
    });
  }

  getIndustryCategory() {
    this.searchService.getIndustryCategory().subscribe(data => {
      if (data.stateCode == "1") {
        this.industris = data.data;
      } else if (data.stateCode == "0") {
        this.showMsg.error("省份条件查询失败");
      }
      setTimeout(() => {
        this.conEffect(this);
      }, 500);
    }, error => {
    });
  }

  // 查看企业详细页面
  openEnterDetail(id) {
    this.router.navigate(['/enterpBasicArchives'], {queryParams: {companyId: id}});
  }


  // 重置条件
  resetCondition() {
    let thiis = this;
    $(".crumb-select-item").each(function () {
      $(this).remove();
    });

    $(".show-con a").each(function () {
      var TT = $(this).text();
      var THI = $(this);
      var THIPP = $(this).parents("dl");
      thiis.params.conditions[$(this).attr("type")] = '';
      THI.removeClass("nzw12");
      THIPP.css("display", "block");
    });

    this.params = new SearchParams();
    if (thiis.keyword != null) {
      this.searchByConditon();
    } else {
      this.showMsg.error("请输入查询关键词");
    }
    /* this.advanceSearch();*/
    /*this.searchByConditon();*/
  }

  // 页面动态效果
  public conEffect(thiis) {

    $(".shaixuan-tj ").on('hover', 'span.crumb-select-item', function (event) {
      if (event.type == 'mouseenter') {
        $(this).addClass("crumb-select-itemon");
      } else {
        $(this).removeClass("crumb-select-itemon");
      }
    });
    $(".shaixuan-tj").on('click', 'span.crumb-select-item', function (event) {
      event.preventDefault();
      $(this).remove();
      var TTR = $(this).find("em").text();
      $(".show-con a").each(function () {
        var TT = $(this).text();
        var THI = $(this);
        var THIPP = $(this).parents("dl");
        if (TTR == TT) {
          thiis.params.conditions[$(this).attr("type")] = '';
          THI.removeClass("nzw12");
          THIPP.css("display", "block");
        }
      });
      thiis.params.page.pageNo = 1;
      thiis.advanceSearch();
    });

    $(".show-con a").click(function (event) {
      event.preventDefault();
      var THIP = $(this).parents("dl");
      if ($(this).hasClass("nzw12")) {
      } else {
        $(this).addClass("nzw12");
        let zhiclass = $(this).parents("dd").siblings("dt").find("a").text();
        let zhicon = $(this).text();
        let tianjaneir = "<span class='crumb-select-item'><a href='/'><b>" + zhiclass + "</b><em>"
          + zhicon + "</em><i class='icon-remove'></i></a></span>";
        $(".shaixuan-tj").children().last().after(tianjaneir);
        THIP.css("display", "none");
      }

      thiis.params.conditions[$(this).attr("type")] = $(this).html();
      thiis.params.page.pageNo = 1;
      thiis.advanceSearch();

    });
    $(".show-more").click(function (event) {
      event.preventDefault();
      var ticon = $(this).find("i");
      var tspan = $(this).find("span");
      if ($(this).hasClass("zk")) {
        $(this).siblings(".show-con").css("height", "30px");
        ticon.removeClass("icon-angle-up");
        ticon.addClass("icon-angle-down");
        tspan.html("更多");
        $(this).removeClass("zk");
      } else {
        $(this).siblings(".show-con").css("height", "auto");
        ticon.removeClass("icon-angle-down");
        ticon.addClass("icon-angle-up");
        tspan.html("收起");
        $(this).addClass("zk");
      }
    });
    $("#sxbtn").click(function (event) {
      event.preventDefault();
      var xicon = $(this).find("span i");
      var xspan = $(this).find("span em");
      if ($(this).hasClass("zkon")) {
        // xspan.text("收起筛选");
        xicon.removeClass("icon-angle-down");
        xicon.addClass("icon-angle-up");
        $(".sxcon").slideDown();
        $(this).removeClass("zkon");
      } else {
        // xspan.text("查看筛选");
        xicon.removeClass("icon-angle-up");
        xicon.addClass("icon-angle-down");
        $(".sxcon").slideUp();
        $(this).addClass("zkon");
      }
    });
  }

  //弹出登录页面
  openLogin() {
    let thiss = this;
    this.showAlert.open({
      zIndex: 5,
      content: LoginModalComponent,
      width: 360,
      footer: false,
      onCancel() {
      },
      onOk() {
      },
    });
  }

}

export class SearchParams {
  public page: Page;
  public conditions = {};

  constructor() {
    this.page = new Page();
    this.conditions = {
      Name: '',
      OperName: '',
      isFromSearch: '',
      Status: '',
      regist_capi: '',
      startYear: '',
      Province: '',
      Industry: '',
      pageNo: 1,
      pageSize: 10,
      highLight: 1 // 设置高亮
    };
  }
}

export class Company {
  public id: string;
  public companyName: string;// 公司名
  public creditCode: string;// 统一社会信用码
  public legalPerson: string;// 法定代表人
  public establishmentDate: Date;// 成立日期
  public address: string;// 地址
  public authStatus: string;// 入驻状态 1，2未入驻、3已入驻
  public authStatusDesc: string;// 入驻状态中文
  public isHighlight: boolean;// 所在行样式
  constructor(item: any, type) {
    if (type == '0') {// 首页
      this.id = item._id;
      this.companyName = item.name;
      this.creditCode = item.creditCode;
      this.establishmentDate = item.startDate;
      this.address = item.address;
    } else {
      this.id = item.companyId;
      this.companyName = item.companyName;
      this.creditCode = item.creditCode;
      this.legalPerson = item.legalPerson;
      this.establishmentDate = item.establishmentDate;
      this.address = item.address;
      this.authStatus = item.authStatus;
      if (item.authStatus == '1' || item.authStatus == '2') {
        this.authStatusDesc = '未入驻';
      } else if (item.authStatus == '3') {
        this.authStatusDesc = '已入驻';
      }
    }
    this.isHighlight = false;
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-news-info/enterp-news-info.component.ts